














































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import Permission from "./component/PermissionV2.vue";
import { authorClient } from "@/api/index";
//import { CommonReq} from "@/pbjs/xcommon/module_pb";
import {
  GetUserGroupTreeByRoleIDReq,
  GetDataPermSummaryByRoleReq,
  ChangeUserGroupInRoleReq,
  CreateRoleReq,
  DeleteRoleReq,
  UpdateRoleReq
} from "@/pbjs/external/auth/auth_pb";
import { setCommon, errorMsg } from "@/utils/request";

@Component({
  name: "system",
  components: { Permission }
})
export default class UserManagement extends Vue {
  @Provide() private placeMessage: string = "Automatic outgoing call record";
  @Provide() private filterText: string = "";
  @Provide() private activeName: string = "first";
  @Provide() private checkData: number[] = [1, 2];
  @Provide() private token: string | null = "";
  @Provide() private roleGroupData: any[] = [];
  @Provide() private oldSelectedNodesArray: any = [];
  @Provide() private permissionData: any[] = [];
  @Provide() private isShowPermission: boolean = true;
  @Provide() private roleid: number = -1;

  @Watch("filterText")
  onFilterTextChanged(val: string) {
    // const ref: any = this.$refs.tree;
    // ref.filter(val);
    this.roleGroupData.forEach((item: any) => {
      if (item.name.indexOf(val) !== -1) {
        item.query = false;
      } else {
        item.query = true;
      }
    });
  }

  private created() {
    this.token = localStorage.getItem("token");
    this.listRole();
  }

  private filterNode(value: string, data: any) {
    if (!value) return true;
    return data.name.indexOf(value) !== -1;
  }

  private doneEditName(index: number) {
    this.roleGroupData[index].edit = false;
    if (this.roleGroupData[index].id == -1) {
      this.createRole(this.roleGroupData[index].name);
    } else {
      this.updateRole(
        this.roleGroupData[index].id,
        this.roleGroupData[index].name
      );
    }
  }

  private editName(index: number) {
    this.roleGroupData[index].edit = true;
  }

  private deleteRoleGroup(id: number | string) {
    this.$confirm(this.$tc("authority.confirmDelete"), "tips", {
      confirmButtonText: this.$tc("ticket.Sure"),
      cancelButtonText: this.$tc("authority.cancel"),
      type: "warning"
    }).then(() => {
      this.deleteRole(id);
    });
  }

  private addNewRoleGroup() {
    this.roleGroupData.push({ id: -1, label: "", edit: true });
  }

  private addPropertyEdit(data: any) {
    data.forEach((item: any) => {
      item.edit = false;
      item.label = item.rolename;
      item.id = item.roleid;
      item.children = item.kidrolesList;
      if (item.kidrolesList) {
        this.addPropertyEdit(item.kidrolesList);
      }
    });
    return data;
  }

  private refreshData() {
    this.listUserGroupByRoleID(this.roleid);
  }

  private listRole() {
    let request: any = setCommon();
    authorClient.listRole(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.roleGroupData = data.roletreeList;
          this.filterText = "";
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private createRole(name: string) {
    let request: any = new CreateRoleReq();
    request.setName(name);
    request.setCommonin(setCommon());
    authorClient.createRole(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.listRole();
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private updateRole(id: number, name: string) {
    let request: any = new UpdateRoleReq();
    request.setCommonin(setCommon());
    request.setRoleid(id);
    request.setModifyname(name);
    authorClient.updateRole(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.listRole();
          this.$message({ type: "success", message: "successfully" });
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private deleteRole(id: number | string) {
    let request: any = new DeleteRoleReq();
    request.setCommonin(setCommon());
    request.setRoleid(id);
    authorClient.deleteRole(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (data.code == "100135") {
          this.$message({
            type: "warning",
            message: "角色组内有角色，不能删除"
          });
        } else if (!data.commonout || data.commonout.code == 0) {
          this.listRole();
          this.$message({ type: "success", message: "successfully" });
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private listUserGroupByRoleID(id: number) {
    this.roleid = id;
    if (id != -1) {
      let request: any = new GetUserGroupTreeByRoleIDReq();
      request.setCommonin(setCommon());
      request.setRoleid(id);
      authorClient.getUserGroupTreeByRoleID(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            let data: any = response.toObject();
            if (!data.commonout || data.commonout.code == 0) {
              this.permissionData = data.usergrouptreeList;
              this.oldSelectedNodesArray = [];
              this.findSelectedNodes(this.permissionData);
              this.isShowPermission = true;
            } else {
              this.$message.error(data.commonout.errmsg);
            }
          }
          if (err) {
            errorMsg(err);
          }
        }
      );
    }
  }

  private findSelectedNodes(data: any) {
    data.forEach((item: any) => {
      if (item.mark == 1) {
        this.oldSelectedNodesArray.push(item.id);
      }
      if (item.kidsList) {
        this.findSelectedNodes(item.kidsList);
      }
    });
  }

  private returnAssign() {}
}
